import React from 'react';
import { Wrapper } from './style';
import { FiEye } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default ({ value }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    console.log('Navigate', value);
    navigate(`/special-tasks/${value}`);
  };
  return (
    <>
      <Wrapper onClick={handleNavigate}>
        <FiEye size={24} color='#3380FF' />
      </Wrapper>
    </>
  );
};
